import { render, staticRenderFns } from "./NCSA.vue?vue&type=template&id=6f06a423"
import script from "./NCSA.vue?vue&type=script&lang=js"
export * from "./NCSA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports